import { QueryTuple, useLazyQuery } from '@apollo/client';
import { GET_ROD_REQUESTS_DETAILS_BY_IDS } from '@bechtel/client-gql';
import { RodRequest } from '@bechtel/types';

export function useRodRequestsDetailsByIdsQuery(
  fetchFromNetwork?: boolean
): QueryTuple<{ rodRequestsByIds: RodRequest[] }, Record<string, any>> {
  const response = useLazyQuery<{
    rodRequestsByIds: RodRequest[];
  }>(
    GET_ROD_REQUESTS_DETAILS_BY_IDS,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
